// apps/client/src/world/objects/dropbox.ts — the shop's drop box (assets/builders/dropbox.ts), static
import type { ObjectView } from '../objectView';

export const view: ObjectView = {
  kinds: ['dropbox'],
  async build(obj, ctx) {
    const o = await ctx.assets.model(obj.catalogId);
    o.userData.static = true;
    return o;
  },
};
